<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <Toasts></Toasts>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      v-model="username"
                      placeholder="Username"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      v-model="password"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        @click="handleLogin()"
                        class="px-4"
                        >Login</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                      @click="forgotPasword()"
                        >Forgot password?</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width:44%"
            >
              <b-card-body class="text-center justify-content-center">
                <img
                  class="navbar-brand-full"
                  src="img/brand/new_logo2.png"
                  width="270em"
                  height="auto"
                  alt="CoreUI Logo"
                />
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import router from "../../router";
export default {
  components: {
    router
  },
  name: "Login",
  data: function() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    handleLogin() {
      let params = {};
      params = {
        user: this.username,
        pass: this.password
      };
      this.$http
        .get("api/auth/login.php", {
          params
        })
        .then(
          res => {
            if (res.data.status === "SUCCESS") {
              localStorage.setItem("user", res.data.user_id);
              localStorage.setItem("user_picture", res.data.user_picture);
              localStorage.setItem("full_name", res.data.full_name);
              localStorage.setItem("token", res.data.token);
              router.push("/");
            } else {
              if (res.data.error == "Please use OEM portal") {
                this.$toast.error("Please use OEM portal");
              } else {
                this.$toast.error("Wrong username or password");
              }
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    forgotPasword() {
      router.push('/pages/forgot-password', {email: this.username})
    }
  }
};
</script>
